import React from "react";

/**
 * Shared layout for legal pages (Privacy, Terms, Cookies).
 * Keeps typography, spacing and structure consistent.
 */

export const LegalPage = ({ overline, title, effectiveDate, children, testId }) => {
  return (
    <div data-testid={testId} className="bg-white">
      <section>
        <div className="container-tight pt-16 md:pt-24 pb-8">
          <div className="max-w-3xl">
            {overline && <div className="overline reveal">{overline}</div>}
            <h1 className="reveal reveal-delay-1 mt-6 font-display text-4xl sm:text-5xl lg:text-[60px] font-bold tracking-tight text-navy leading-[1.05]">
              {title}
            </h1>
            {effectiveDate && (
              <p className="reveal reveal-delay-2 mt-6 text-[13px] uppercase tracking-[0.18em] text-charcoal/70">
                Effective {effectiveDate}
              </p>
            )}
          </div>
        </div>
      </section>

      <section className="pb-20 md:pb-28">
        <div className="container-tight">
          <article className="max-w-3xl space-y-12 text-[15.5px] leading-relaxed text-charcoal">
            {children}
          </article>
        </div>
      </section>
    </div>
  );
};

export const LegalSection = ({ number, title, children, testId }) => (
  <section data-testid={testId} className="border-t border-border pt-10">
    <div className="flex items-baseline gap-4">
      {number && (
        <span className="font-display text-[13px] font-bold tracking-[0.2em] text-warm">
          {String(number).padStart(2, "0")}
        </span>
      )}
      <h2 className="font-display text-xl sm:text-2xl font-semibold text-navy tracking-tight">
        {title}
      </h2>
    </div>
    <div className="mt-5 space-y-4">{children}</div>
  </section>
);

export const LegalList = ({ items }) => (
  <ul className="space-y-2.5">
    {items.map((it, i) => (
      <li key={i} className="flex items-start gap-3">
        <span className="mt-2 h-1.5 w-1.5 rounded-full bg-warm shrink-0" />
        <span>{it}</span>
      </li>
    ))}
  </ul>
);

export default LegalPage;
